// extracted by mini-css-extract-plugin
export var backdropBlur = "_e8-0";
export var contentCard = "_e8-5";
export var frame = "_e8-2";
export var image = "_e8-4";
export var imagePane = "_e8-3";
export var modal = "_e8-1";